import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MPFFilterPill } from 'volto-ministerio-publico-federal/components/UI';

const NewsCategoryPicker = ({ items, selected, onChange }) => {
  // O vocabulário chega por requisição, depois do primeiro render: um tema que
  // veio pela URL precisa aparecer marcado nesse intervalo.
  const options = useMemo(() => {
    const fromVocabulary = (items || [])
      .filter((item) => item.value !== '__novalue__')
      .map((item) => item.label);

    const missing = selected.filter((tema) => !fromVocabulary.includes(tema));

    return [...fromVocabulary, ...missing];
  }, [items, selected]);

  // Atualizador, não valor pronto: dois cliques no mesmo lote partiriam ambos
  // da mesma lista e a segunda categoria apagaria a primeira.
  const toggle = (tema) => {
    onChange((current) =>
      current.includes(tema)
        ? current.filter((item) => item !== tema)
        : [...current, tema],
    );
  };

  return (
    <fieldset className="mpf-news-filter__categories">
      <legend className="mpf-news-filter__categories-title">Categorias</legend>
      <div className="mpf-news-filter__categories-list">
        <MPFFilterPill
          label="Todas as Notícias"
          selected={selected.length === 0}
          showRemoveIcon={false}
          onToggle={() => onChange(() => [])}
        />
        {options.map((tema) => (
          <MPFFilterPill
            key={tema}
            label={tema}
            selected={selected.includes(tema)}
            onToggle={() => toggle(tema)}
          />
        ))}
      </div>
    </fieldset>
  );
};

NewsCategoryPicker.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Recebe um atualizador `(atual) => próximo`, nunca a lista pronta. */
  onChange: PropTypes.func.isRequired,
};

NewsCategoryPicker.defaultProps = {
  items: [],
};

export default NewsCategoryPicker;
